import { createContext } from 'react';

import { SourceMenuText } from 'containers/Visibility/SecurityGraphNext/utils/sourceOptions';

// Gives the entity dropdown's menu list its header and footer text; the shared
// Select doesn't pass extra props through to its components.
export const SourceMenuTextContext = createContext<SourceMenuText>({});
